import { useState } from 'react';
import { Plus } from 'lucide-react';
import { useQueryClient } from '@tanstack/react-query';
import { ProductFilters } from './components/ProductFilters';
import { ProductTable } from './components/ProductTable';
import { ProductForm } from './components/ProductForm';
import { CreditPackTable } from './components/CreditPackTable';
import { CreditPackForm } from './components/CreditPackForm';

export default function ProductsPage() {
  const queryClient = useQueryClient();
  const [activeTab, setActiveTab] = useState<'collections' | 'credit-packs'>('collections');
  const [creatingProduct, setCreatingProduct] = useState(false);
  const [creatingPack, setCreatingPack] = useState(false);

  return (
    <div className="space-y-6">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h2 className="font-display text-3xl font-bold">Product Catalog</h2>
          <p className="text-sm text-on-surface-variant mt-1">
            Manage single-publish Collections and Partner Credit Pack volume pricing.
          </p>
        </div>
        {activeTab === 'collections' ? (
          <button
            onClick={() => setCreatingProduct(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-electric-violet text-white text-xs font-bold uppercase tracking-widest hover:bg-electric-violet/90 transition-colors shadow-sm"
          >
            <Plus className="w-4 h-4" /> Create collection
          </button>
        ) : (
          <button
            onClick={() => setCreatingPack(true)}
            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-electric-violet text-white text-xs font-bold uppercase tracking-widest hover:bg-electric-violet/90 transition-colors shadow-sm"
          >
            <Plus className="w-4 h-4" /> Create credit pack
          </button>
        )}
      </div>

      {/* Tabs */}
      <div className="flex border-b border-border-subtle gap-6">
        <button
          onClick={() => setActiveTab('collections')}
          className={`pb-3 text-sm font-semibold tracking-wide border-b-2 transition-colors ${
            activeTab === 'collections'
              ? 'border-electric-violet text-electric-violet'
              : 'border-transparent text-on-surface-variant hover:text-on-surface'
          }`}
        >
          Collections (Single Publish)
        </button>
        <button
          onClick={() => setActiveTab('credit-packs')}
          className={`pb-3 text-sm font-semibold tracking-wide border-b-2 transition-colors ${
            activeTab === 'credit-packs'
              ? 'border-electric-violet text-electric-violet'
              : 'border-transparent text-on-surface-variant hover:text-on-surface'
          }`}
        >
          Partner Credit Packs (10 / 30 / 73 Ladder)
        </button>
      </div>

      {activeTab === 'collections' ? (
        <>
          <ProductFilters />
          <ProductTable />
          <ProductForm open={creatingProduct} mode="create" onClose={() => setCreatingProduct(false)} />
        </>
      ) : (
        <>
          <CreditPackTable />
          <CreditPackForm
            open={creatingPack}
            mode="create"
            onClose={() => setCreatingPack(false)}
            onSuccess={() => {
              queryClient.invalidateQueries({ queryKey: ['admin', 'credit-packs'] });
            }}
          />
        </>
      )}
    </div>
  );
}
